import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRoseyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    viewBox="0 0 22 22"
    {...props}
  >
    <path
      fill="url(#a)"
      fillRule="evenodd"
      d="M10.145 2.011a2.011 2.011 0 1 1-4.022 0 2.011 2.011 0 0 1 4.022 0m-1.056 0a.955.955 0 1 1-1.91 0 .955.955 0 0 1 1.91 0"
      clipRule="evenodd"
    />
    <path
      fill="url(#b)"
      d="M17.23 1.288c-.16-.544-.93-.544-1.09 0l-.232.795a2.27 2.27 0 0 1-1.541 1.541l-.795.232c-.544.16-.544.93 0 1.09l.795.232a2.27 2.27 0 0 1 1.541 1.541l.232.795c.16.544.93.544 1.09 0l.232-.795a2.27 2.27 0 0 1 1.541-1.541l.795-.233c.544-.159.544-.93 0-1.089l-.795-.232a2.27 2.27 0 0 1-1.541-1.541z"
    />
    <path
      fill="url(#c)"
      d="M11.685 8.536a1.76 1.76 0 0 1 1.98.025l4.19 2.93.041.03 2.444 1.598a.748.748 0 0 1-.818 1.252l-.916-.598v6.467a1.76 1.76 0 0 1-1.76 1.76H8.493a.88.88 0 0 1 0-1.76h8.351v-7.306l-4.189-2.93-1.462.967a.88.88 0 1 1-.971-1.468z"
    />
    <path
      fill="url(#d)"
      d="M5.926 9.932c.218-.748 1.278-.748 1.497 0l.32 1.093a3.12 3.12 0 0 0 2.119 2.119l1.092.32c.748.218.748 1.278 0 1.497l-1.092.32a3.12 3.12 0 0 0-2.12 2.118l-.319 1.093c-.219.748-1.279.748-1.497 0l-.32-1.093a3.12 3.12 0 0 0-2.119-2.119l-1.093-.32c-.748-.218-.748-1.278 0-1.497l1.093-.32a3.12 3.12 0 0 0 2.119-2.118z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={17.875}
        x2={7.792}
        y1={21.542}
        y2={11.458}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3752B3" />
        <stop offset={1} stopColor="#DE5930" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={17.875}
        x2={7.792}
        y1={21.542}
        y2={11.458}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3752B3" />
        <stop offset={1} stopColor="#DE5930" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={17.875}
        x2={7.792}
        y1={21.542}
        y2={11.458}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3752B3" />
        <stop offset={1} stopColor="#DE5930" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={17.875}
        x2={7.792}
        y1={21.542}
        y2={11.458}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3752B3" />
        <stop offset={1} stopColor="#DE5930" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgRoseyIcon;
